import { FormattedMessage } from 'react-intl';

import { AnimatedNumber } from '@sorare/core/src/atoms/animations/AnimatedNumber';
import { StarBall } from '@sorare/core/src/atoms/icons/StarBall';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, LabelS } from '@sorare/core/src/atoms/typography';

type Props = { currentIndex: number; numberOfCards: number };
export const FirstPackTitle = ({ currentIndex, numberOfCards }: Props) => {
  return (
    <Vertical center gap={0.5}>
      <StarBall />
      <BrandM className="text-center">
        <FormattedMessage
          id="FirstPackTitle.yourTeam"
          defaultMessage="Your team"
        />
      </BrandM>
      <LabelS bold>
        <AnimatedNumber value={currentIndex + 1} />/{numberOfCards}
      </LabelS>
    </Vertical>
  );
};
